<template>
    <modal
        :title="translations.title || 'Cancel request'"
        :cancel_btn_title="translations.no || 'No'"
        size="small"
    >
        <template #toggle>
            <btn type="light" size="small">
                {{ translations.cancel || 'Cancel' }}
            </btn>
        </template>
        <template #body>
            <div>
                <fieldset>
                    <div class="-space-y-px bg-white rounded-md text-left">
                        {{ translations.cancelQuestion || 'Do you really want to cancel payout request ?' }}
                    </div>
                </fieldset>
            </div>
        </template>
        <template #footer>
            <btn type="primary" @click="cancelPayout">
                {{ translations.cancelConfirmation || 'Yes, Cancel Request' }}
            </btn>
        </template>
    </modal>
</template>
<script>
export default {
    props: ['payout_id', 'cancel_url', 'translations'],
    data() {
        return {}
    },
    methods: {
        cancelPayout() {
            const self = this;
            axios.post(self.cancel_url, {payout: self.payout_id})
                .then(response => {
                    const status = parseInt(response.data.status || -1);
                    if (status === 1) {
                        window.location.reload();
                    }
                })
                .catch(error => {
                });
        }
    }
}
</script>
